<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Expiring" subtitle="See all expiring subscriptions.">

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		<app-content-filters-checklist v-if="references.types.length" v-model="filter.types" text="Type" tooltip="Filter by type" :options="references.types" />
		<app-content-filters-checklist v-if="references.tags.length" v-model="filter.tags" text="Tag" tooltip="Filter by tag" :options="references.tags" />
		<app-content-filters-select v-model="filter.sort" :alwaysLabel="true" :alwaysValue="true" text="Sort by" tooltip="Change sorting" :options="$util.options(filterSortOptions)" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no subscriptions found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="No." />
				<app-table-column text="Ref." />
				<app-table-column :sorted="filter.sort === 'name'" text="Name" />
				<app-table-column />
				<app-table-column text="Type" />
				<app-table-column :sorted="filter.sort === 'date'" text="Expiring" />
				<app-table-column border="left" text="Billing" />

			</app-table-head>

			<app-table-body>

				<app-table-row align="top" :selected="isSelected(item.id)" :warning="!item.status" v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.reference" />
					<app-table-cell-text :text="item.referenceRandom" />
					<app-table-cell-text :text="item.name" />
					<app-table-cell-labels align="right" :labels="tagLabels(item)" />
					<app-table-cell-text :text="item.type.name" />
					<app-table-cell-text :text="item.date.renew | localDate('DD MMMM YYYY')" />
					<app-table-cell-labels border="left" :labels="billingLabels(item)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			layout: '48px 72px auto auto 100px 140px 240px',
			references: {
				tags: [],
				types: []
			},
			filter: {
				tags: [],
				types: [],
				sort: 'name'
			},
            filterSortOptions: {
                'name': 'Name',
                'date': 'Started'
            },
			endpoint: 'membership/members/expiring',
			live: 'membership/members/expiring',
			edit: 'Membership.Members.Subscriptions.Edit'
		}

	},

	computed: {

		importexportData: function() {

			var columns = {}
			var required = []
			var mapping = {}

			columns['reference'] = 'Number'
			columns['referenceRandom'] = 'Reference'
			columns['status'] = 'Status'
			columns['firstname'] = 'First name'
			columns['lastname'] = 'Last name'
			columns['email'] = 'Email'
			columns['type'] = 'Type'

			mapping = {
				type: this.filterTypeOptions
			}

			columns['date'] = 'Date'

			return {
				columns: columns,
				requiredColumns: required,
				valueMapping: mapping,
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.endpoint
			}

		},

		filterTypeOptions: function() {

			var options = []

			this.$_.each(this.references.types, function(type) {

				options.push({
					value: type.id,
					text: type.name
				})
			
			})

			return this.$_.sortBy(options, 'text')

		},

		filterStatusOptions: function() {

			var options = []

			this.$_.each(this.references.status, function(text, value) {

				options.push({
					value: value,
					text: text
				})
			
			})

			return this.$_.sortBy(options, 'text')

		}

	},

	methods: {

		onRestoreClick: function() {

			//

		},
	
		billingLabels: function(item) {
		
			var labels = []

			labels.push({
				type: this.$constants.membership.subscription.billing.statusColour[item.billing.status],
				text: this.$constants.membership.subscription.billing.statusName[item.billing.status]
			})

			labels.push({
				type: this.$constants.membership.subscription.billing.typeColour[item.billing.type],
				text: this.$constants.membership.subscription.billing.typeName[item.billing.type]
			})

			labels.push({
				type: this.$constants.membership.subscription.billing.cycleColour[item.billing.cycle],
				text: this.$constants.membership.subscription.billing.cycleName[item.billing.cycle]
			})

			return labels
		
		},
	
		tagLabels: function(item) {
		
			var labels = []
			var templateUsed = []

			this.$_.each(item.tags, function(tag) {

				if(!this.$_.contains(templateUsed, tag.template.id)) {
				
					labels.push({
						colour: tag.template.colour,
						text: tag.template.label,
						tooltip: tag.template.name
					})

					templateUsed.push(tag.template.id)

				}
			
			}.bind(this))

			return labels
		
		}
	
	}

}

</script>

<style scoped>

</style>